<template>
  <document-content url_prefix="/formateur/clients" />
</template>
<script setup lang="ts">
  import DocumentContent from '@/components/refonte/documents/document-content.vue';
</script>

<style lang="scss" scoped></style>
